function transformStyleProperty({ style }) {
  return style;
}
export {
  transformStyleProperty
};
